import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { inputBorderColor } from '../../../../styles/colors';

const { spacing, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	dropdownRow: {
		display: 'flex',
		gap: spacing.sm,
		fontSize: typography.fontSizes.xs,
		padding: spacing.xs,
	},
	dropdownContentInnerOverrides: {
		// inputBorderColor (#CCCCCC) has no exact THEME token; retained to match the other filter dropdowns.
		borderColor: inputBorderColor,
		borderBottomLeftRadius: common.borderRadius,
		borderBottomRightRadius: common.borderRadius,
		borderTopRightRadius: 0,
		maxHeight: 500,
	},
});
